import { render } from "./DashboardReturns.vue?vue&type=template&id=55835bbf"
import script from "./DashboardReturns.vue?vue&type=script&lang=js"
export * from "./DashboardReturns.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__